

export function containsChild({ target = {}, child = {} }) {
    
    function findChild(options = {}) {
        const { node } = options;

        if(node === child) {
            options.stop = true;
            options.value = true;
        };

        return options;
    };

    return crawler({
        outputHandler: findChild,
        node: target,
        value: false
    });
};

export function crawler(options = {}) {
    const { 
        node = {},
        nestedLevel = -1, 
        outputHandler = (() => null) 
    } = options;

    const { children = [] } = node || {};
    const { length = 0 } = children;
    const level = nestedLevel + 1;
    let index = 0;
    let result = {
        ...options,
        ...outputHandler({ ...options, nestedLevel: level })
    };

    for (index; index < length; index++) {

        result = {
            ...result,
            ...crawler({
                ...result,
                parent: node,
                nestedLevel: level,
                node: children[index]
            })
        };

        if(result.stop) {
            break;
        };
    };

    return result;
};